/**
 * set-distribution-parser.js — TEK KAYNAK (canonical) toptan-set dağılım parser'ı.
 *
 * Hem ürün sayfası (quantity-multiplier.js) hem sepet (cart-set-multiplier.js) AYNI fonksiyonu,
 * AYNI girdilerle (ham açıklama + ürünün GERÇEK bedenleri) çağırır → ikisi asla ayrışamaz.
 * Bu, "1XL" gibi belirsiz token'ların gerçek bedenlere göre tutarlı çözülmesini sağlar ve
 * eski iki-ayrı-parser tutarsızlığını (sepette 60 yerine 80) kökten giderir.
 *
 * window.ToserofSetParser.parse(description, availableSizes, productTitle) → {
 *   found, type: 'beden_seti'|'multi_size_set'|'std'|'none',
 *   isMultiSize, distribution:{SIZE:qty}, distributions:{RANGE:total},
 *   totalPerSet, multiplier
 * }
 */
(function () {
  'use strict';
  if (typeof window !== 'undefined' && window.ToserofSetParser) return; // çift-yükleme guard'ı

  var EXCLUDED_WORDS = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK', 'STD']);
  var VALID_SIZES = new Set(['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL']);
  var EXTENDED_SIZES = new Set(['1XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL']);

  function normSize(s) { return String(s == null ? '' : s).toUpperCase().replace(/[()]/g, '').trim(); }

  function isValidSize(size) {
    if (!size) return false;
    size = normSize(size);
    if (!size) return false;
    if (EXCLUDED_WORDS.has(size)) return false;
    if (VALID_SIZES.has(size) || EXTENDED_SIZES.has(size)) return true;
    if (/^\d{2,3}$/.test(size)) { var n = parseInt(size, 10); return n >= 18 && n <= 200; }
    if (size.includes('-')) { var p = size.split('-'); return p.length === 2 && p[0] && p[1] && isValidSize(p[0]) && isValidSize(p[1]); }
    if (size.includes('/')) { var q = size.split('/'); return q.length === 2 && q[0] && q[1] && isValidSize(q[0]) && isValidSize(q[1]); }
    return false;
  }

  // availableSizes → normalize edilmiş Set (disambiguation için).
  function buildAvailSet(availableSizes) {
    var set = new Set();
    (availableSizes || []).forEach(function (s) { var n = normSize(s); if (n) set.add(n); });
    return set;
  }

  // Belirsiz "qty+harf" token'ını çöz. wholeToken="1XL": availSet'te tam eşleşirse beden adı (1XL),
  // değilse qty(1)+beden(XL). Extended olmayan ("2S") her zaman qty+beden.
  function resolveQtyToken(qty, letters, wholeToken, availSet) {
    var whole = normSize(wholeToken);
    var lettersN = normSize(letters);
    if (EXTENDED_SIZES.has(whole)) {
      // Belirsiz: gerçek bedenlerde "1XL" var mı?
      if (availSet.has(whole)) return { size: whole, qty: 1 };
      // yoksa qty + basic-size (örn. 1XL → 1 adet XL), ama XL gerçekten bedenlerde olmalı ya da availSet boş olmalı
      if (VALID_SIZES.has(lettersN) && (availSet.size === 0 || availSet.has(lettersN))) return { size: lettersN, qty: qty };
      // son çare: bedenlerde XL yoksa ama 1XL extended ise, 1XL'i beden say
      return { size: whole, qty: 1 };
    }
    if (VALID_SIZES.has(lettersN)) return { size: lettersN, qty: qty };
    return null;
  }

  // "34- 1" → "34-1", "XL- 1" → "XL-1": ayraç sonrası kayan boşluğu kapat (dağılım token'ı + adet).
  function normDistSpacing(s) { return String(s == null ? '' : s).replace(/([0-9A-Za-z)\]])\s*-\s+(\d)/g, '$1-$2'); }

  // "SM","LXL","SML" gibi bitişik bileşik beden — yalnız geçerli bedenlere TAM ayrışıyorsa true.
  function isCompound(s) {
    s = normSize(s);
    if (s.length < 2) return false;
    var order = ['XXXL', 'XXL', 'XL', 'XS', 'S', 'M', 'L'];
    var i = 0;
    while (i < s.length) {
      var matched = false;
      for (var k = 0; k < order.length; k++) { if (s.indexOf(order[k], i) === i) { i += order[k].length; matched = true; break; } }
      if (!matched) return false;
    }
    return true;
  }

  // "Değişken" beden seti — adet açıklamada yok, beden adında: "(36-42-6)" → toplam 6.
  // Tek varyant → std-N; çok varyant (her biri -N içeriyorsa) → beden_seti {beden: N}.
  function deriveFromSizes(sizes) {
    var arr = (sizes || []).map(normSize).filter(Boolean);
    if (!arr.length) return null;
    var dist = {}, all = true;
    arr.forEach(function (s) {
      // Adet YALNIZCA 3+ bileşende var: "36-42-6"=aralık 36-42 +adet 6, "S-L-3", "S+L+3".
      // 2 bileşen ("26-31","S-XL") = sadece ARALIK, adet yok → türetme (üst sınırı adet sanma!).
      var parts = s.split(/[-+]/).filter(Boolean);
      var last = parts.length >= 3 ? parseInt(parts[parts.length - 1], 10) : NaN;
      if (parts.length >= 3 && last >= 1 && last <= 20) { dist[s] = last; } else { all = false; }
    });
    var keys = Object.keys(dist);
    if (!all || keys.length === 0) return null;
    if (keys.length === 1) return { found: true, type: 'std', isMultiSize: false, multiplier: dist[keys[0]] };
    return { found: true, type: 'beden_seti', isMultiSize: true, distributions: dist, totalPerRange: dist };
  }

  function cleanText(text) {
    if (!text) return '';
    return String(text)
      .replace(/<[^>]*>/g, ' ')
      .replace(/&[a-zA-Z0-9#]+;/g, ' ')
      .replace(/\*+/g, ' ')
      .replace(/[\r\n\t\f\v]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ---- MULTI-SIZE dağılım parser'ı (disambiguation-aware) ----
  // text: "2S-2M-1L-1XL" | "S-2 M-2 L-1 XL-1" | "44-1 46-2" | "(S-M)-3" | "1XL-2XL-3XL" ...
  function parseMultiSize(text, availSet) {
    var dist = {};
    var t = normDistSpacing(cleanText(text));
    if (!t) return dist;

    // 1) qty"x"size: "1x38-1x40", "2xS-2xM" (lowercase x; "1XL" çakışmasın diye case-sensitive)
    var xm = Array.from(t.matchAll(/(\d+)\s*x\s*(\d{2,3}|[A-Za-z]{1,4})(?=[-\s,]|$)/g));
    if (xm.length) {
      var ok = false;
      xm.forEach(function (m) { var q = parseInt(m[1], 10), s = normSize(m[2]); if (q > 0 && q <= 100 && isValidSize(s)) { dist[s] = q; ok = true; } });
      if (ok) return dist;
    }

    var tokens = t.split(/[\s,]+/).map(function (x) { return x.trim(); }).filter(function (x) { return x && !/^[-:=]+$/.test(x); });

    // 2) Ayraçlı token pass (hepsini topla): "S-2","S:2","44-1","(S-M)-3","M/L:1","S-M-3","7-8-1"
    var any = false;
    tokens.forEach(function (tok) { if (parseSeparatedToken(tok, dist, availSet)) any = true; });
    if (any && Object.keys(dist).length > 0) return dist;
    dist = {};

    // 3) Boşluksuz bitişik multi-size — TOKEN-BAZINDA, İLK anlamlı token kazanır (açıklama prose'unu atlar).
    //    Ürün sayfasının davranışıyla birebir: "S1-M2-L2-XL1 Bu ürün %100..." → ilk token çözülür, gerisi yok sayılır.
    for (var i = 0; i < tokens.length; i++) {
      var tmp = {};
      parseAttached(tokens[i], tmp, availSet);
      if (Object.keys(tmp).length > 0) return tmp;
    }

    // 4) Sadece beden isimleri (adet yok): "S M L XL" / "S-M-L-XL" → her birinden 1
    var loneTokens = t.split(/[\s,\-]+/).map(normSize).filter(Boolean);
    loneTokens.forEach(function (s) { if ((VALID_SIZES.has(s) || EXTENDED_SIZES.has(s)) && !dist[s]) dist[s] = 1; });
    return dist;
  }

  // Açık ayraçlı tek token: "S-2","S:2","44-1","(S-M)-3","M/L:1","S-M-3","2XL-3XL-2"
  function parseSeparatedToken(token, dist, availSet) {
    if (!token) return false;
    var m;
    // yaş aralığı tek token: "7-8-1" → range "7-8" qty 1 (sadece saf rakam; "S-M-3" buraya düşmez)
    m = token.match(/^(\d{1,2}-\d{1,2})-(\d{1,2})$/);
    if (m) { var q0 = parseInt(m[2], 10); if (q0 > 0 && q0 <= 100) { dist[m[1]] = q0; return true; } }
    // (S-M)-3 / (S-M):3
    m = token.match(/^\(([\w/-]+)\)\s*[-:=]\s*(\d{1,3})$/);
    if (m) { var s1 = normSize(m[1]), q1 = parseInt(m[2], 10); if (q1 > 0 && q1 <= 100 && isValidSize(s1)) { dist[s1] = q1; return true; } }
    // <size>[-:=]<qty> — son ayraçtan sonrası adet. "S-2","S-M-2","2XL-3XL-2","44-1","M/L:1"
    m = token.match(/^(.+?)\s*[-:=]\s*(\d{1,3})$/);
    if (m) {
      var s2 = normSize(m[1]), q2 = parseInt(m[2], 10);
      if (q2 > 0 && q2 <= 100 && isValidSize(s2)) { dist[s2] = q2; return true; }
    }
    // qty+harf bitişik tek token: "2S" (ama "1XL" → resolveQtyToken)
    m = token.match(/^(\d+)([A-Za-z]+)$/);
    if (m) {
      var r = resolveQtyToken(parseInt(m[1], 10), m[2], m[0], availSet);
      if (r && r.qty > 0 && r.qty <= 100) { dist[r.size] = r.qty; return true; }
    }
    // harf+qty bitişik: "S1"
    m = token.match(/^([A-Za-z]+)(\d{1,2})$/);
    if (m) { var s4 = normSize(m[1]), q4 = parseInt(m[2], 10); if (q4 > 0 && q4 <= 100 && VALID_SIZES.has(s4)) { dist[s4] = q4; return true; } }
    // tek sayısal beden "36"
    m = token.match(/^(\d{2,3})$/); if (m && isValidSize(m[1])) { dist[m[1]] = 1; return true; }
    // tek harf/extended beden "S" / "1XL"
    var sn = normSize(token);
    if (VALID_SIZES.has(sn) || EXTENDED_SIZES.has(sn)) { dist[sn] = 1; return true; }
    return false;
  }

  // Boşluksuz bitişik multi-size taraması (disambiguation-aware)
  function parseAttached(text, dist, availSet) {
    var found = false, matches;
    // yaş aralığı: "7-8-1 9-10-1"
    matches = Array.from(text.matchAll(/(\d{1,2}-\d{1,2})-(\d{1,2})/g));
    if (matches.length) {
      var got = false;
      matches.forEach(function (mm) { var q = parseInt(mm[2], 10); if (q > 0 && q <= 100) { dist[mm[1]] = q; got = true; } });
      if (got) return;
    }
    // qty+harf: "2S-2M-1L-1XL", "1S-1M-1L-1XL"  (en kritik — disambiguation burada)
    matches = Array.from(text.matchAll(/(\d+)([A-Za-z]{1,4})(?=[-\s,]|$)/g));
    if (matches.length) {
      matches.forEach(function (mm) {
        var r = resolveQtyToken(parseInt(mm[1], 10), mm[2], mm[0], availSet);
        if (r && r.qty > 0 && r.qty <= 100) { dist[r.size] = r.qty; found = true; }
      });
      if (found) return;
    }
    // harf+qty: "S1-M1-L1-XL1"
    matches = Array.from(text.matchAll(/([A-Za-z]{1,4})(\d{1,2})(?=[-\s,]|$)/g));
    if (matches.length) {
      matches.forEach(function (mm) { var s = normSize(mm[1]), q = parseInt(mm[2], 10); if (VALID_SIZES.has(s) && q > 0 && q <= 100) { dist[s] = q; found = true; } });
      if (found) return;
    }
    // sadece extended beden isimleri: "1XL-2XL-3XL" (yalnız availSet'te varsa beden say; yoksa qty+size yukarıda işlendi)
    Array.from(text.matchAll(/(\d[A-Za-z]{1,3})(?=[-\s,]|$)/g)).forEach(function (mm) {
      var s = normSize(mm[1]); if (EXTENDED_SIZES.has(s) && (availSet.has(s) || availSet.size === 0)) dist[s] = dist[s] || 1;
    });
  }

  // ---- STD ----
  function parseStd(text) {
    var t = cleanText(text);
    var m = t.match(/\bSTD\s*[-:]?\s*(\d+)/i);                    // STD6 / STD-6 / STD:6 / STD 6
    if (!m) m = t.match(/(\d+)\s*x\s*(?:STANDART|STD|STN)\b/i);   // 6xSTD
    if (!m) m = t.match(/\bSTN\s*[-:]?\s*(\d+)/i);                // STN-1
    if (!m) m = t.match(/\bSTANDART\s*[-:]?\s*(\d+)(?!\s*(?:KALIP|KESIM|KESİM|BEDEN|EBAT))/i); // STANDART6 / STANDART-6
    if (!m) m = t.match(/(\d+)\s+STANDART(?!\s*(?:KALIP|KESIM|KESİM|BEDEN|EBAT))/i);
    if (!m) m = t.match(/\bSTANDARD\s*\(\s*(\d+)\s*PIECE/i);      // Standard (2 pieces)
    if (m) { var n = parseInt(m[1], 10); if (n > 0 && n < 100) return n; }
    if (/\bONE\s*SIZE\b/i.test(t) || /\bTEK\s*BEDEN\b/i.test(t)) return 1;
    return 0;
  }

  // ---- Paket Yapısı: "1S+1M+1L+1XL" / "36+38+40+42" ----
  function parsePaket(content, availSet) {
    var parts = cleanText(content).split('+').map(function (p) { return p.trim(); }).filter(Boolean);
    var dist = {};
    parts.forEach(function (part) {
      var m = part.match(/^(\d+)([A-Za-z]+)$/);
      if (m) {
        var qp = parseInt(m[1], 10), lp = normSize(m[2]);
        var r = resolveQtyToken(qp, m[2], m[0], availSet);
        if (r && r.qty > 0) { dist[r.size] = (dist[r.size] || 0) + r.qty; return; }
        if (/^(STD|STANDART|STN|STANDARD)$/.test(lp)) { if (qp > 0) dist.STD = (dist.STD || 0) + qp; return; } // "4STD"
        if (isCompound(lp)) { if (qp > 0) dist[lp] = (dist[lp] || 0) + qp; return; }                          // "2SM","2LXL"
        return;
      }
      m = part.match(/^(\d{2,3})$/); if (m) { dist[m[1]] = (dist[m[1]] || 0) + 1; return; }
      var sn = normSize(part); if (VALID_SIZES.has(sn) || EXTENDED_SIZES.has(sn)) dist[sn] = (dist[sn] || 0) + 1;
    });
    return dist;
  }

  // ---- Beden Seti: "(S-XL) Dağılım: S:1 - M:1 ..." → {RANGE: total} ----
  function parseBedenSeti(clean) {
    var distributions = {};
    var sections = clean.split('Beden Seti:');
    for (var i = 1; i < sections.length; i++) {
      var section = sections[i];
      var dp = section.split('Dağılım:');
      if (dp.length > 1) {
        var range = normSize(dp[0]);
        var content = dp[1].split(/Barkod|Teknik|$/)[0].trim();
        var total = 0;
        var mm = content.matchAll(/([A-Z]{1,3}(?:\/[A-Z]{1,3})?|\d{1,3}):(\d+)/g);
        for (var x of mm) { total += parseInt(x[2], 10) || 0; }
        if (range && range !== 'OPTION' && total > 0) distributions[range] = total;
      }
    }
    return distributions;
  }

  // Compound key genişletme: {S-M:3} ve gerçek bedenler [S,M] → {S:3,M:3}
  function expandCompound(distribution, availSet) {
    if (!distribution || Object.keys(distribution).length === 0) return distribution;
    var expanded = {};
    Object.keys(distribution).forEach(function (key) {
      var qty = distribution[key];
      var k = normSize(key);
      if (k.includes('-') && !availSet.has(k)) {
        var parts = k.split('-').map(function (s) { return s.trim(); }).filter(Boolean);
        var allMatch = parts.length > 0 && parts.every(function (p) { return availSet.has(p) || VALID_SIZES.has(p) || EXTENDED_SIZES.has(p) || /^\d{2,3}$/.test(p); });
        if (allMatch) { parts.forEach(function (p) { expanded[p] = (expanded[p] || 0) + qty; }); return; }
      }
      expanded[k] = (expanded[k] || 0) + qty;
    });
    return expanded;
  }

  // Etiketten sonra YALNIZCA baştaki dağılım token'larını tut; ilk dağılım-olmayan (prose) kelimede dur.
  // "S1-M2-L2-XL1 Bu ürün ... 38 beden" → "S1-M2-L2-XL1" (prose'taki 38/100 dışarıda kalır).
  function leadingDist(content, availSet) {
    if (!content) return content;
    content = normDistSpacing(content);
    var toks = content.split(/\s+/);
    var kept = [];
    for (var i = 0; i < toks.length; i++) {
      var tok = (toks[i] || '').trim();
      if (!tok || /^[-:=,]+$/.test(tok)) continue;
      var tmp = {};
      var ok = parseSeparatedToken(tok, tmp, availSet);
      if (!ok) { tmp = {}; parseAttached(tok, tmp, availSet); ok = Object.keys(tmp).length > 0; }
      if (ok) kept.push(tok); else break;
    }
    return kept.length ? kept.join(' ') : content;
  }

  var sum = function (o) { return Object.keys(o).reduce(function (s, k) { return s + o[k]; }, 0); };

  // ---- ANA GİRİŞ ----
  function parse(description, availableSizes, productTitle) {
    var none = { found: false, type: 'none', isMultiSize: false };
    if (!description) return none;
    var availSet = buildAvailSet(availableSizes);
    var raw = String(description);
    var clean = cleanText(raw);

    // Format tespiti — set-multiplier.liquid ile AYNI öncelik sırası
    var hasBedenSetiLabel = clean.indexOf('Beden Seti:') >= 0;
    var hasBedenSeti = hasBedenSetiLabel && clean.indexOf('Dağılım:') >= 0;
    var setLabel = raw.indexOf('Set İçerik Bilgisi:') >= 0 ? 'Set İçerik Bilgisi:' :
                   raw.indexOf('Set Icerik Bilgisi:') >= 0 ? 'Set Icerik Bilgisi:' : null;
    var hasDagilim = !setLabel && clean.indexOf('Dağılım:') >= 0 && !hasBedenSeti;
    var hasPaket = raw.indexOf('Paket Yapısı:') >= 0;

    // 1) Beden Seti
    if (hasBedenSeti) {
      var distributions = parseBedenSeti(clean);
      if (Object.keys(distributions).length > 0) {
        return { found: true, type: 'beden_seti', isMultiSize: true, distributions: distributions, totalPerRange: distributions };
      }
    }

    // 1b) Beden Seti "Değişken" — "Dağılım:" yok ya da parse edilemedi → adet beden adında: "(36-42-6)" → 6
    if (hasBedenSetiLabel) {
      var derivedBS = deriveFromSizes(availableSizes);
      if (derivedBS) return derivedBS;
    }

    // 2) Set İçerik Bilgisi (starred + plain)
    function extractAfter(label) {
      var idx = raw.indexOf(label);
      if (idx < 0) return null;
      var after = raw.slice(idx + label.length);
      after = cleanText(after);
      var enders = ['MALZEMELER', 'Teknik', 'Kumaş', 'Kalıp', 'Kol', 'Beden', 'Bakım', 'Ürün', 'Model', 'Varyasyonlar', 'Barkod'];
      for (var e = 0; e < enders.length; e++) { var p = after.indexOf(enders[e]); if (p > 0) { after = after.slice(0, p); break; } }
      return after.trim();
    }

    if (setLabel) {
      var content = extractAfter(setLabel);
      if (content) {
        // İçerik STD olabilir (örn. "Set İçerik Bilgisi: STD-5" / "STD6" / "STANDART-6" / "STN-1")
        var stdInline = /\bSTD\d|\bSTD\b|STANDART|STANDARD|\bSTN\b|\bSTN\d/i.test(content) && !/\d[SML]/i.test(content);
        if (stdInline) { var sm = parseStd(content); if (sm > 0) return { found: true, type: 'std', isMultiSize: false, multiplier: sm }; }
        if (/TEK\s*BEDEN|ONE\s*SIZE/i.test(content)) return { found: true, type: 'std', isMultiSize: false, multiplier: 1 };
        // Tek varyantlı ürün: "dağılım" anlamsız (tek satılabilir ünite var) → adet hesapla, beden dağıtma.
        if (availSet.size <= 1) {
          var labIdx = raw.indexOf(setLabel) + setLabel.length;
          var dimRaw = raw.slice(labIdx, labIdx + 60);
          // ÖLÇÜ sinyali: "cm", veya "×"/"*" ayraçlı sayı çifti (23*33). Düz "x" SAYILMAZ — "1x38" = adet×beden (set).
          var isDim = /\bcm\b/i.test(content) || /\d\s*[×*]\s*\d/.test(dimRaw);
          var tn = content.match(/-\s*(\d{1,2})\s*$/);
          if (isDim) return { found: true, type: 'std', isMultiSize: false, multiplier: tn ? parseInt(tn[1], 10) : 1 };
          // "3 Lü Set-1": önek bir dağılım DEĞİLse, ad=beden, son N=adet → std-N (gerçek dağılım ise multi-size'a bırak)
          if (tn) {
            var pfx = parseMultiSize(content.replace(/-\s*\d{1,2}\s*$/, ''), availSet);
            if (Object.keys(pfx).length === 0) { var q = parseInt(tn[1], 10); if (q > 0 && q < 100) return { found: true, type: 'std', isMultiSize: false, multiplier: q }; }
          }
        }
        var d = expandCompound(parseMultiSize(leadingDist(content, availSet), availSet), availSet);
        if (Object.keys(d).length > 0) return { found: true, type: 'multi_size_set', isMultiSize: true, distribution: d, totalPerSet: sum(d) };
      }
    }

    // 3) Dağılım:
    if (hasDagilim) {
      var idx = raw.indexOf('Dağılım:');
      var dcontent = cleanText(raw.slice(idx + 'Dağılım:'.length)).split(/Teknik|Kumaş|Barkod/)[0].trim();
      var dd = expandCompound(parseMultiSize(leadingDist(dcontent, availSet), availSet), availSet);
      if (Object.keys(dd).length > 0) return { found: true, type: 'multi_size_set', isMultiSize: true, distribution: dd, totalPerSet: sum(dd) };
    }

    // 4) Paket Yapısı
    if (hasPaket) {
      var pidx = raw.indexOf('Paket Yapısı:');
      var pcontent = cleanText(raw.slice(pidx + 'Paket Yapısı:'.length)).split(/Teknik|Kumaş|Barkod/)[0].trim();
      // sıkı: sadece sayı/harf/+/-/space, ilk Türkçe küçük-harf kelimeye kadar
      var pm = pcontent.match(/^([\dA-Z\s+\-]+?)(?=\s*[A-ZÇĞİÖŞÜ][a-zçğıöşüİı]|$)/);
      var pc = pm ? pm[1].trim() : pcontent;
      var pd = expandCompound(parsePaket(pc, availSet), availSet);
      var pk = Object.keys(pd);
      if (pk.length === 1 && pk[0] === 'STD') return { found: true, type: 'std', isMultiSize: false, multiplier: pd.STD }; // "4STD"
      if (pk.length > 0) return { found: true, type: 'multi_size_set', isMultiSize: true, distribution: pd, totalPerSet: sum(pd) };
    }

    // 5) STD
    var std = parseStd(clean);
    if (std > 0 && (/\bSTD\d|\bSTD\b|STANDART|STANDARD|\bSTN\b|\bSTN\d|TEK\s*BEDEN|ONE\s*SIZE/i.test(clean))) {
      return { found: true, type: 'std', isMultiSize: false, multiplier: std };
    }

    return none;
  }

  window.ToserofSetParser = { parse: parse, _internal: { parseMultiSize: parseMultiSize, parseStd: parseStd, parsePaket: parsePaket, expandCompound: expandCompound, buildAvailSet: buildAvailSet, VALID_SIZES: VALID_SIZES, EXTENDED_SIZES: EXTENDED_SIZES } };
})();
